import './HomePage.css';

const HomePage = () => {
  return (
    <>
      <header className="menu-home">
        <nav>
          <svg
            width="45"
            height="44"
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12.4292 10C11.3246 10 10.4292 10.8954 10.4292 12C10.4292 13.1046 11.3246 14 12.4292 14C13.5338 14 14.4292 13.1046 14.4292 12C14.4292 10.8954 13.5338 10 12.4292 10ZM8.4292 12C8.4292 9.79086 10.2201 8 12.4292 8C14.6383 8 16.4292 9.79086 16.4292 12C16.4292 14.2091 14.6383 16 12.4292 16C10.2201 16 8.4292 14.2091 8.4292 12Z"
              fill="#2a2a2a"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12.4292 4C12.2604 4 12.0986 4.06705 11.9792 4.18639C11.8599 4.30573 11.7928 4.46759 11.7928 4.63636V4.77944C11.791 5.23775 11.6552 5.68551 11.4021 6.06762C11.1491 6.44973 10.7898 6.74951 10.3686 6.93005C10.29 6.96373 10.2076 6.98711 10.1235 6.99977C9.74563 7.1288 9.33994 7.15978 8.94485 7.08814C8.48284 7.00437 8.05651 6.78411 7.72084 6.45577L7.71296 6.44806L7.66391 6.39892C7.60481 6.33976 7.53423 6.29243 7.45698 6.2604C7.37973 6.22838 7.29692 6.21189 7.21329 6.21189C7.12966 6.21189 7.04685 6.22838 6.9696 6.2604C6.89235 6.29243 6.82216 6.33937 6.76306 6.39853L6.76228 6.39932C6.70311 6.45842 6.65617 6.5286 6.62415 6.60586C6.59212 6.68311 6.57564 6.76592 6.57564 6.84955C6.57564 6.93317 6.59212 7.01598 6.62415 7.09323C6.65617 7.17049 6.70311 7.24067 6.76228 7.29977L6.81956 7.35706C7.1479 7.69272 7.36811 8.11909 7.45189 8.58111C7.53378 9.03276 7.48157 9.49826 7.30208 9.92022C7.13732 10.3503 6.84971 10.7227 6.47474 10.9909C6.0912 11.2652 5.634 11.4178 5.16258 11.4288L5.1392 11.4291H5.06556C4.89679 11.4291 4.73493 11.4961 4.61559 11.6155C4.49624 11.7348 4.4292 11.8967 4.4292 12.0655C4.4292 12.2342 4.49624 12.3961 4.61559 12.5154C4.73493 12.6348 4.89679 12.7018 5.06556 12.7018H5.20864C5.66694 12.7036 6.11471 12.8395 6.49682 13.0925C6.87745 13.3446 7.17638 13.702 7.35714 14.1212C7.54499 14.5495 7.60079 15.0241 7.51734 15.4843C7.43357 15.9464 7.21331 16.3727 6.88497 16.7084L6.87726 16.7162L6.82812 16.7653C6.76896 16.8244 6.72163 16.895 6.6896 16.9722C6.65758 17.0495 6.64109 17.1323 6.64109 17.2159C6.64109 17.2995 6.65758 17.3823 6.6896 17.4596C6.72163 17.5369 6.76857 17.607 6.82773 17.6661L6.82852 17.6669C6.88762 17.7261 6.9578 17.773 7.03506 17.8051C7.11231 17.8371 7.19512 17.8536 7.27874 17.8536C7.36237 17.8536 7.44518 17.8371 7.52243 17.8051C7.59969 17.773 7.66987 17.7261 7.72897 17.6669L7.78625 17.6096C8.12192 17.2813 8.54829 17.0611 9.01031 16.9773C9.46195 16.8954 9.92745 16.9476 10.3494 17.1271C10.7795 17.2919 11.1519 17.5795 11.4201 17.9545C11.6944 18.338 11.847 18.7952 11.858 19.2666L11.8583 19.29V19.3636C11.8583 19.5324 11.9253 19.6943 12.0447 19.8136C12.164 19.933 12.3259 20 12.4947 20C12.6634 20 12.8253 19.933 12.9446 19.8136C13.064 19.6943 13.131 19.5324 13.131 19.3636V19.2245L13.131 19.2206C13.1329 18.7623 13.2687 18.3145 13.5217 17.9324C13.7738 17.5518 14.1312 17.2528 14.5504 17.0721C14.9787 16.8842 15.4533 16.8284 15.9135 16.9119C16.3756 16.9956 16.8019 17.2159 17.1376 17.5442L17.1454 17.5519L17.1945 17.6011C17.2536 17.6602 17.3242 17.7076 17.4014 17.7396C17.4787 17.7716 17.5615 17.7881 17.6451 17.7881C17.7287 17.7881 17.8115 17.7716 17.8888 17.7396C17.9661 17.7076 18.0362 17.6606 18.0953 17.6015L18.0961 17.6007C18.1553 17.5416 18.2022 17.4714 18.2343 17.3941C18.2663 17.3169 18.2828 17.2341 18.2828 17.1505C18.2828 17.0668 18.2663 16.984 18.2343 16.9068C18.2022 16.8295 18.1553 16.7593 18.0961 16.7002L18.0388 16.6429C17.7105 16.3073 17.4903 15.8809 17.4065 15.4189C17.3231 14.9586 17.3789 14.484 17.5667 14.0557C17.7475 13.6366 18.0464 13.2791 18.427 13.0271C18.8091 12.774 19.2569 12.6382 19.7152 12.6364L19.7192 12.6364L19.7928 12.6364C19.9616 12.6364 20.1235 12.5693 20.2428 12.45C20.3622 12.3306 20.4292 12.1688 20.4292 12C20.4292 11.8312 20.3622 11.6694 20.2428 11.55C20.1235 11.4307 19.9616 11.3636 19.7928 11.3636H19.6537L19.6498 11.3636C19.1915 11.3618 18.7437 11.226 18.3616 10.9729C17.9795 10.7199 17.6797 10.3606 17.4992 9.93939C17.4655 9.86081 17.4421 9.77844 17.4294 9.6943C17.3004 9.31643 17.2694 8.91074 17.3411 8.51565C17.4248 8.05364 17.6451 7.62731 17.9734 7.29164L17.9811 7.28376L18.0303 7.23471C18.0894 7.17561 18.1368 7.10503 18.1688 7.02778C18.2008 6.95053 18.2173 6.86772 18.2173 6.78409C18.2173 6.70046 18.2008 6.61766 18.1688 6.5404C18.1368 6.46315 18.0898 6.39297 18.0307 6.33386L18.0299 6.33308C17.9708 6.27391 17.9006 6.22697 17.8233 6.19495C17.7461 6.16292 17.6633 6.14644 17.5797 6.14644C17.496 6.14644 17.4132 6.16292 17.336 6.19495C17.2587 6.22697 17.1885 6.27391 17.1294 6.33308L17.0721 6.39036C16.7365 6.7187 16.3101 6.93892 15.8481 7.02269C15.3878 7.10614 14.9132 7.05034 14.4849 6.86249C14.0658 6.68173 13.7083 6.3828 13.4563 6.00217C13.2032 5.62006 13.0674 5.17229 13.0656 4.71399L13.0656 4.71V4.63636C13.0656 4.46759 12.9985 4.30573 12.8792 4.18639C12.7598 4.06705 12.598 4 12.4292 4ZM18.4837 14.4545L19.3986 14.8583C19.3704 14.9223 19.3619 14.9933 19.3744 15.0621C19.3867 15.1297 19.4185 15.1921 19.466 15.2417L19.5096 15.2852C19.7547 15.5301 19.9491 15.8208 20.0818 16.1409C20.2145 16.4609 20.2828 16.804 20.2828 17.1505C20.2828 17.4969 20.2145 17.84 20.0818 18.16C19.9491 18.4801 19.7547 18.7708 19.5096 19.0157L18.8033 18.3086L19.5103 19.0149C19.2655 19.26 18.9747 19.4545 18.6547 19.5871C18.3346 19.7198 17.9916 19.7881 17.6451 19.7881C17.2986 19.7881 16.9556 19.7198 16.6355 19.5871C16.3155 19.4545 16.0247 19.26 15.7799 19.0149L15.7364 18.9714C15.6868 18.9239 15.6243 18.892 15.5567 18.8798C15.4879 18.8673 15.4169 18.8757 15.353 18.904L15.3432 18.9083C15.2804 18.9352 15.2269 18.9798 15.1892 19.0367C15.1518 19.0932 15.1316 19.1593 15.131 19.2271V19.3636C15.131 20.0628 14.8533 20.7334 14.3588 21.2278C13.8644 21.7222 13.1939 22 12.4947 22C11.7954 22 11.1249 21.7222 10.6305 21.2278C10.136 20.7334 9.85829 20.0628 9.85829 19.3636V19.3055C9.85519 19.2381 9.83266 19.1729 9.79334 19.118C9.75248 19.0608 9.69539 19.0173 9.62947 18.9931C9.6097 18.9858 9.59016 18.9779 9.57089 18.9694C9.50691 18.9412 9.43594 18.9327 9.36713 18.9452C9.29953 18.9575 9.23707 18.9894 9.18749 19.0368L9.14397 19.0804C9.14384 19.0805 9.1441 19.0802 9.14397 19.0804C8.8992 19.3253 8.60819 19.52 8.28831 19.6526C7.96827 19.7853 7.62521 19.8536 7.27874 19.8536C6.93228 19.8536 6.58922 19.7853 6.26917 19.6526C5.94913 19.5199 5.65837 19.3255 5.41352 19.0804C5.16877 18.8357 4.97459 18.5452 4.84206 18.2255C4.70938 17.9054 4.64109 17.5624 4.64109 17.2159C4.64109 16.8694 4.70938 16.5264 4.84206 16.2063C4.97466 15.8865 5.16898 15.5958 5.41391 15.3511C5.41378 15.3512 5.41404 15.3509 5.41391 15.3511L5.45784 15.3071C5.50531 15.2576 5.53717 15.1951 5.54943 15.1275C5.56191 15.0587 5.55348 14.9877 5.52525 14.9238L5.52092 14.914C5.49403 14.8512 5.44943 14.7977 5.39252 14.76C5.33601 14.7226 5.26985 14.7024 5.20209 14.7018H5.06556C4.36636 14.7018 3.69579 14.4241 3.20137 13.9296C2.70696 13.4352 2.4292 12.7647 2.4292 12.0655C2.4292 11.3662 2.70696 10.6957 3.20137 10.2013C3.69579 9.70685 4.36636 9.42909 5.06556 9.42909H5.1237C5.19111 9.42599 5.25626 9.40346 5.31124 9.36414C5.36836 9.32328 5.41188 9.26619 5.43612 9.20027C5.44339 9.1805 5.45128 9.16096 5.45979 9.14169C5.48803 9.07771 5.49645 9.00674 5.48397 8.93793C5.47172 8.87033 5.43985 8.80787 5.39237 8.7583L5.34885 8.71477C5.10373 8.46993 4.90927 8.17916 4.7766 7.85912C4.64393 7.53907 4.57564 7.196 4.57564 6.84955C4.57564 6.50309 4.64393 6.16002 4.7766 5.83998C4.9092 5.5201 5.10352 5.22948 5.34846 4.98471C5.59322 4.73978 5.88384 4.54546 6.20372 4.41286C6.52377 4.28018 6.86683 4.21189 7.21329 4.21189C7.55975 4.21189 7.90281 4.28018 8.22286 4.41286C8.54291 4.54553 8.83367 4.73998 9.07852 4.9851L9.12204 5.02863C9.17162 5.0761 9.23408 5.10797 9.30167 5.12023C9.37048 5.13271 9.44145 5.12428 9.50543 5.09605C9.55675 5.0734 9.60975 5.05517 9.66384 5.04148C9.69112 5.01927 9.71503 4.99296 9.73466 4.96332C9.77211 4.90677 9.79231 4.84057 9.79284 4.77277V4.63636C9.79284 3.93716 10.0706 3.26659 10.565 2.77217C11.0594 2.27776 11.73 2 12.4292 2C13.1284 2 13.799 2.27776 14.2934 2.77217C14.7878 3.26659 15.0656 3.93716 15.0656 4.63636V4.70744C15.0661 4.7752 15.0863 4.84135 15.1237 4.89787C15.1614 4.95478 15.2149 4.99943 15.2777 5.02631L15.2875 5.03054C15.3515 5.05878 15.4225 5.06725 15.4913 5.05477C15.5589 5.04252 15.6213 5.01065 15.6709 4.96319L15.7144 4.91965C15.7143 4.91978 15.7146 4.91952 15.7144 4.91965C15.9592 4.67471 16.2502 4.48 16.5701 4.3474C16.8901 4.21473 17.2332 4.14644 17.5797 4.14644C17.9261 4.14644 18.2692 4.21473 18.5892 4.3474C18.9089 4.47993 19.1994 4.67412 19.4441 4.91886C19.6892 5.16371 19.8837 5.45447 20.0163 5.77452C20.149 6.09457 20.2173 6.43763 20.2173 6.78409C20.2173 7.13055 20.149 7.47361 20.0163 7.79366C19.8837 8.11354 19.6894 8.40416 19.4445 8.64892C19.4444 8.64905 19.4446 8.64879 19.4445 8.64892L19.4006 8.69283C19.3531 8.74241 19.3212 8.80488 19.309 8.87247C19.2965 8.94129 19.3049 9.01226 19.3332 9.07623C19.3558 9.12755 19.374 9.18054 19.3877 9.23463C19.4099 9.26191 19.4362 9.28583 19.4659 9.30546C19.5224 9.34291 19.5886 9.36311 19.6564 9.36364H19.7928C20.492 9.36364 21.1626 9.6414 21.657 10.1358C22.1514 10.6302 22.4292 11.3008 22.4292 12C22.4292 12.6992 22.1514 13.3698 21.657 13.8642C21.1626 14.3586 20.492 14.6364 19.7928 14.6364H19.7218C19.654 14.6369 19.5878 14.6571 19.5313 14.6945C19.4744 14.7322 19.4298 14.7857 19.4029 14.8485L18.4837 14.4545Z"
              fill="#2a2a2a"
            />
          </svg>
          <ul>
            <li className="seller-btn-mini" onClick={() => (window.location.href = '/login')}>
              Faça Login
            </li>
            <li
              className="seller-btn-mini full"
              onClick={() =>
                window.open(
                  'https://pay.hotmart.com/A84861204S?sck=HOTMART_PRODUCT_PAGE&off=fwegce2x&hotfeature=32&bid=1784727345179',
                  '_blank',
                )
              }
            >
              Adquira o software
            </li>
          </ul>
        </nav>
      </header>
      <div className="banner">
        <div className="banner-overlay">
          <h1>Fabrique engrenagens de forma simples e eficiente com precisão extrema.</h1>
          <p>
            Você quer aprender a fabricar suas engrenagens desse modo e{' '}
            <span className="under">com varias opções de montagem</span> para sua máquina fresadora?
          </p>
          <br />
          <br />
          <br />
          <br />
          <button
            className="seller-btn full"
            onClick={() =>
              window.open(
                'https://pay.hotmart.com/A84861204S?sck=HOTMART_PRODUCT_PAGE&off=fwegce2x&hotfeature=32&bid=1784727345179',
                '_blank',
              )
            }
          >
            Adquira o software
          </button>
          <span className="skip-or">
            <i>Já possui o software então</i>
          </span>
          <button className="seller-btn" onClick={() => (window.location.href = '/login')}>
            Faça o login
          </button>
        </div>
      </div>

      <main>
        <div className="section">
          <br />
          <br />
          <br />
          <p className="main-text">
            Este metodo já é uma realidade e esta sendo utilizado por fresadores profissionais para
            fabricação de engrenagens retas ou helicoidais em diversos processos como o corte dente
            a dente na fresadora universal e em corte por geração como na renania adaptada na
            fresadora universal e na renania industrial
          </p>
          <br />
          <br />
          <br />

          <h2 className="sub-title">Montagem de grade completa para</h2>
          <ul>
            <li>Fresadora universal</li>
            <li>Renania adaptada</li>
            <li>Coroa e sem-fim</li>
            <li>Engrenagem espiral cônica</li>
            <li>Engrenagem cônica reta de 15 e 20 graus</li>
          </ul>

          <h2 className="sub-title">Benefícios</h2>
          <ul>
            <li>
              Aumento de lucratividade com fabricação de engrenagens para redutores e máquinas em
              geral
            </li>
            <li>
              Aumento de lucro com a diminuição do tempo de preparação de máquina e consequente
              aumento de produção
            </li>
            <li>
              Maior vida útil das engrenagens fabricadas devido maior precião dos cálculos em sua
              fabricação
            </li>
            <li>Eliminação de estresse do operador de máquina.</li>
            <li>Eliminação de refugos</li>
          </ul>
        </div>
        <div className="section-extended secondary-painted">
          <div className="flex justify-center items-center w-full">
            <div className="section">
              <h2 className="sub-title sub-title-no-space">Relatos</h2>
            </div>
          </div>
          <div className="block-items-list">
            <div className="block-item">
              <iframe
                src="https://www.youtube.com/embed/tpMFeF1fLdo?si=7kjxJdMtH7h3rtpw"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen
              ></iframe>
              <span>
                Arlindo Martins aprendeu a fazer engrenagem helicoidal com o Software Renania
              </span>
            </div>

            <div className="block-item">
              <iframe
                src="https://www.youtube.com/embed/_bCzL64qJsM?si=b1UVcxwzMBB5nB9i"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen
              ></iframe>
              <span>
                Danilo de Selviria MS utiliza o Software Renania para fazer engrenagens helicoidais
              </span>
            </div>

            <div className="block-item">
              <iframe
                src="https://www.youtube.com/embed/mqeskTGlq2k?si=N2BoyQ9YutTzD9Oa"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen
              ></iframe>
              <span>Cláudio aprendeu a fresar coroa de redutor com Software Renania</span>
            </div>

            <div className="block-item">
              <iframe
                src="https://www.youtube.com/embed/hDSJPfJaA2E?si=WwrJ3VI5-Q9h63xV"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen
              ></iframe>
              <span>Software Renania aplicado na Renania adaptada na fresadora universal</span>
            </div>
          </div>
        </div>
        <div className="section">
          <h2 className="sub-title">Quem sou eu?</h2>
          <p>
            Sou Ewerson Breda Teixeira, Engenheiro de Produção Mecânica, com mais de 19 anos de
            experiência na indústria metalúrgica, registrado no CREA-SP (5063469177).
          </p>
          <br />
          <p>
            Ao longo da minha trajetória, percebi os desafios que muitos fresadores — experientes ou
            iniciantes — enfrentam na preparação de máquinas para a fabricação de engrenagens,
            especialmente as helicoidais. Para transformar essa realidade, desenvolvi o Software
            Renania, uma solução inovadora projetada para otimizar seu trabalho, aumentar sua
            produtividade e elevar seus lucros.
          </p>
          <br />
          <p>
            Com um passo a passo detalhado e totalmente online, você terá acesso a instruções
            precisas para produzir engrenagens retas e helicoidais de maneira prática e eficiente.
            Nosso método é intuitivo, direto e de alta qualidade, guiando você em cada etapa do
            processo com clareza e segurança.
          </p>
          <br />
          <p>
            Independentemente do modelo da sua fresadora universal ou geradora Renania, o Software
            Renania foi criado para simplificar sua rotina e garantir resultados excepcionais.
          </p>
          <br />
          <p>
            Estou animado para embarcar com você nessa jornada de evolução e sucesso. Vamos juntos
            levar suas habilidades a um novo patamar!
          </p>

          <h2 className="sub-title">Q&A</h2>
          <div className="qa-line">
            <span className="qa-line-title">
              Quantas horas por dia são necessárias para a prática?
            </span>
            <p>
              <span className="text-red-600 font-bold">R:</span> Você precisa de menos de 50 minutos
              diários para aprender este método.
            </p>
          </div>

          <div className="qa-line">
            <span className="qa-line-title">
              O Software Renania funciona em qualquer máquina fresadora?
            </span>
            <p>
              <span className="text-red-600 font-bold">R:</span> Sim. O software é configurável para
              diferentes tipos de fresadoras, incluindo fresadoras universais, Renania adaptada e
              Renania Industrial.
            </p>
          </div>

          <div className="qa-line">
            <span className="qa-line-title">O Software Renania roda no celular?</span>
            <p>
              <span className="text-red-600 font-bold">R:</span> Sim. O Software Renania pode ser
              acessado em qualquer computador ou celular com conexão à internet.
            </p>
          </div>

          <div className="qa-line">
            <span className="qa-line-title">Após a compra, em quanto tempo recebo o conteúdo?</span>
            <p>
              <span className="text-red-600 font-bold">R:</span> O acesso ao Software Renania,
              juntamente com e-mail e senha, é liberado imediatamente após a confirmação da compra.{' '}
              <strong>
                Caso ocorra alguma demora, entre em contato diretamente via WhatsApp: (14) 9
                9842-1100.
              </strong>
            </p>
          </div>

          <div className="qa-line">
            <span className="qa-line-title">
              O Software Renania realiza cálculos para engrenagens helicoidais?
            </span>
            <p>
              <span className="text-red-600 font-bold">R:</span> Sim. O software foi desenvolvido
              para fornecer a grade de engrenagens para qualquer método de fresamento.
            </p>
          </div>

          <div className="qa-line">
            <span className="qa-line-title">Em quanto tempo posso ver resultados?</span>
            <p>
              <span className="text-red-600 font-bold">R:</span> Se você já é fresador, pode aplicar
              o método e obter resultados em apenas 10 minutos.
            </p>
          </div>

          <div className="qa-line">
            <span className="qa-line-title">
              Posso utilizar o Software Renania em uma fresadora universal?
            </span>
            <p>
              <span className="text-red-600 font-bold">R:</span> Sim. O Software Renania é
              compatível com fresadoras universais, fornecendo todas as configurações necessárias,
              incluindo opções de disco do divisor, número de voltas, quantidade de furos, grade de
              engrenagens para fabricar engrenagens helicoidais, bem como os parâmetros completos,
              como diâmetro interno, diâmetro primitivo, passo de hélice e muito mais.
            </p>
          </div>

          <div className="qa-line">
            <span className="qa-line-title">
              Após a compra, há algum custo adicional para aprender a usar o software?
            </span>
            <p>
              <span className="text-red-600 font-bold">R:</span> Não. O software inclui uma
              explicação completa sobre sua utilização, com base nos parâmetros da sua máquina.
            </p>
          </div>

          <div className="qa-line">
            <span className="qa-line-title">software gera cálculos para coroa e eixo sem-fim?</span>
            <p>
              <span className="text-red-600 font-bold">R:</span> Sim. O software realiza os cálculos
              necessários para fresar a coroa e a rosca sem-fim, tanto pelo método de fresamento
              dente a dente na fresadora universal quanto pelo método Renania.
            </p>
          </div>

          <div className="qa-line">
            <span className="qa-line-title">
              O software permite inserir o passo do fuso da máquina para cálculo do trem de
              engrenagens?
            </span>
            <p>
              <span className="text-red-600 font-bold">R:</span> Sim. O passo do fuso da sua máquina
              e o número de dentes da coroa do divisor são dados de entrada no software, garantindo
              resultados personalizados para sua máquina.
            </p>
          </div>

          <div className="qa-line">
            <span className="qa-line-title">
              O software fornece apenas o cálculo do trem de engrenagens ou também informa todas as
              dimensões da engrenagem?
            </span>
            <p>
              <span className="text-red-600 font-bold">R:</span> Sim. No método de corte dente a
              dente, você pode inserir os dados da sua fresadora, como passo do fuso e número de
              dentes do divisor, para obter todas as informações necessárias.
            </p>
          </div>

          <div className="qa-line">
            <span className="qa-line-title">
              O software é compatível com engrenagens cônicas helicoidais?
            </span>
            <p>
              <span className="text-red-600 font-bold">R:</span> Sim. O software conta com um módulo
              específico para engrenagens espirais cônica.
            </p>
          </div>

          <div className="qa-line">
            <span className="qa-line-title">
              Em quais sistemas operacionais o software roda? Existe alguma limitação de uso?
            </span>
            <p>
              <span className="text-red-600 font-bold">R:</span> O software é compatível com
              qualquer sistema operacional de computador ou celular. Ele funciona online, bastando
              um navegador e conexão à internet. O acesso é oferecido via assinatura anual.
            </p>
          </div>

          <div className="qa-line">
            <span className="qa-line-title">
              O software calcula a grade da fresadora para produção de rosca sem-fim?
            </span>
            <p>
              <span className="text-red-600 font-bold">R:</span> Sim. Há uma aula específica no
              software explicando como utilizar esse recurso.
            </p>
          </div>

          <div className="qa-line">
            <span className="qa-line-title">
              O software permite a fabricação de engrenagens cilíndricas e de dentes retos?
            </span>
            <p>
              <span className="text-red-600 font-bold">R:</span> Sim. O software fornece as
              informações necessárias, como disco de furos, voltas e número de dentes a percorrer no
              garfo do divisor, para produzir engrenagens cilíndricas de dentes retos e helicoidais.
            </p>
          </div>
        </div>
      </main>
    </>
  );
};

export default HomePage;
